import {
  GET_VENDOR_UPLOAD_REQUEST,
  GET_VENDOR_UPLOAD_SUCCESS,
  GET_VENDOR_UPLOAD_FAILURE,
  GET_VENDOR_DATA_FOR_DOWNLOAD_REQUEST,
  GET_VENDOR_DATA_FOR_DOWNLOAD_SUCCESS,
  GET_VENDOR_DATA_FOR_DOWNLOAD_FAILURE,
  UPLOADCSV_FOR_VENDOR_UPLOAD_REQUEST,
  UPLOADCSV_FOR_VENDOR_UPLOAD_SUCCESS,
  UPLOADCSV_FOR_VENDOR_UPLOAD_FAILURE,
} from "./vendorUploadTypes";

const initialState = {
  loading: false,
  vendorUploadData: [],
  error: "",
};

const vendorUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_UPLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_UPLOAD_SUCCESS:
      return {
        loading: false,
        vendorUploadData: action.payload,
        error: "",
      };
    case GET_VENDOR_UPLOAD_FAILURE:
      return {
        loading: false,
        vendorUploadData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDownload = {
  loading: false,
  vendorDataForDownload: [],
  error: "",
};

const vendorDataForDownloadReducer = (state = initialStateForDownload, action) => {
  switch (action.type) {
    case GET_VENDOR_DATA_FOR_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_DATA_FOR_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        vendorDataForDownload: action.payload,
        error: "",
      };
    case GET_VENDOR_DATA_FOR_DOWNLOAD_FAILURE:
      return {
        loading: false,
        vendorDataForDownload: [],
        error: action.payload,
      };
    default:
      return state;
  }
};




export { vendorUploadReducer, vendorDataForDownloadReducer };
